module.exports = __webpack_public_path__ + "img/67_9.c4c82016.png";